import { render, staticRenderFns } from "./PatientOverallSummary.vue?vue&type=template&id=541e05c8&scoped=true"
import script from "./PatientOverallSummary.vue?vue&type=script&lang=js"
export * from "./PatientOverallSummary.vue?vue&type=script&lang=js"
import style0 from "./PatientOverallSummary.vue?vue&type=style&index=0&id=541e05c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541e05c8",
  null
  
)

export default component.exports